/**
 * Configuração Firebase para Cloud Messaging (push). Sem Analytics: nada de GA no app.
 *
 * ## Segurança
 * - Estas variáveis `VITE_*` são **públicas** no bundle (modelo oficial do Firebase Web).
 * - A **chave privada** do Service Account e o envio FCM no servidor ficam só na Edge Function,
 *   secret `FIREBASE_SERVICE_ACCOUNT_JSON` (Supabase Dashboard → Edge Functions → Secrets).
 * - **Tokens FCM por dispositivo** não ficam aqui: vão para a tabela `push_subscriptions` via
 *   `pushSubscriptionsRepository.registerToken`.
 *
 * Defina no .env:
 *   VITE_FIREBASE_API_KEY=
 *   VITE_FIREBASE_AUTH_DOMAIN=
 *   VITE_FIREBASE_PROJECT_ID=
 *   VITE_FIREBASE_STORAGE_BUCKET=
 *   VITE_FIREBASE_MESSAGING_SENDER_ID=
 *   VITE_FIREBASE_APP_ID=
 *   VITE_FIREBASE_VAPID_KEY=       (obrigatório para push)
 */

const readEnv = (v: string | undefined): string => (v?.trim() ?? '')

export const firebaseConfig = {
  apiKey: readEnv(import.meta.env.VITE_FIREBASE_API_KEY),
  authDomain: readEnv(import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
  projectId: readEnv(import.meta.env.VITE_FIREBASE_PROJECT_ID),
  storageBucket: readEnv(import.meta.env.VITE_FIREBASE_STORAGE_BUCKET),
  messagingSenderId: readEnv(import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID),
  appId: readEnv(import.meta.env.VITE_FIREBASE_APP_ID),
}

export const firebaseVapidKey = readEnv(import.meta.env.VITE_FIREBASE_VAPID_KEY)

const hasMessagingConfig =
  firebaseConfig.apiKey &&
  firebaseConfig.projectId &&
  firebaseConfig.messagingSenderId &&
  firebaseConfig.appId &&
  firebaseVapidKey

/** Firebase configurado para push (messaging). */
export const isFirebaseConfigured = (): boolean => !!hasMessagingConfig
